import Transaction from '../Transaction';

/**
 * One receipt to email. The transactions board mixes Israeli and US donations, whose receipts
 * come from different sources, so every receipt names its own source - also in a selection
 * that mixes the two (HAT-1432).
 */
export interface ReceiptToSendDtoOut {
  receiptId: number;
  /** True for an Israeli receipt, false for a US one */
  defaultReceipt: boolean;
}

export const toReceiptToSend = (transaction: Pick<Transaction, 'receiptId' | 'defaultReceipt'>): ReceiptToSendDtoOut => ({
  receiptId: transaction.receiptId,
  defaultReceipt: transaction.defaultReceipt ?? true,
});

/** The donation receipts of a board selection. Rows of one donation share a receipt, which goes into the email once. */
export const receiptsToSend = (transactions: Transaction[]): ReceiptToSendDtoOut[] =>
  transactions
    .filter((transaction) => transaction.kind === 'תרומה' && transaction.receiptId)
    .map(toReceiptToSend)
    .filter(
      (receipt, index, all) => all.findIndex((other) => other.receiptId === receipt.receiptId && other.defaultReceipt === receipt.defaultReceipt) === index
    );
